export const setColorTheme = (isDark, documentEl = document) => {
  try {
    if (isDark) {
      documentEl.body.classList.add('dark');
      documentEl.documentElement.setAttribute('style', 'color-scheme: dark;');
    } else {
      documentEl.body.classList.remove('dark');
      documentEl.documentElement.setAttribute('style', 'color-scheme: light;');
    }
  } catch (error) {
    // eslint-disable-next-line
    console.error('Failed to apply theme to iframe:', error);
  }
};
